import { render, staticRenderFns } from "./CreateChildPlotDialog.vue?vue&type=template&id=51f5b244&scoped=true"
import script from "./CreateChildPlotDialog.vue?vue&type=script&lang=ts"
export * from "./CreateChildPlotDialog.vue?vue&type=script&lang=ts"
import style0 from "./CreateChildPlotDialog.vue?vue&type=style&index=0&id=51f5b244&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51f5b244",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51f5b244')) {
      api.createRecord('51f5b244', component.options)
    } else {
      api.reload('51f5b244', component.options)
    }
    module.hot.accept("./CreateChildPlotDialog.vue?vue&type=template&id=51f5b244&scoped=true", function () {
      api.rerender('51f5b244', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ui/CreateChildPlotDialog.vue"
export default component.exports